import React from 'react';
import { MessageSquareWarning, Mic, AlertTriangle } from 'lucide-react';

const painPoints = [
  {
    icon: MessageSquareWarning,
    quote: 'O som da igreja dele é melhor…',
    context: 'Ouvido de um colaborador depois do culto'
  },
  {
    icon: Mic,
    quote: 'Com essa mesa cara e a live tá assim?',
    context: 'Comentário que ninguém quer receber'
  },
  {
    icon: AlertTriangle,
    quote: 'Você mexeu em quê? Agora piorou…',
    context: 'Quando você não entende o signal flow'
  }
];

const PainPoints = () => {
  return (
    <section
      id="dores"
      data-testid="pain-points-section"
      className="section-padding relative overflow-hidden bg-black"
    >
      {/* Subtle grid background */}
      <div className="absolute inset-0 bg-grid-pattern opacity-40 pointer-events-none"></div>
      {/* Yellow glow */}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[500px] h-[500px] bg-yellow-500/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-8 md:mb-14">
            <h2
              data-testid="pain-points-title"
              className="text-[1.75rem] leading-tight sm:text-4xl lg:text-5xl font-bold text-white"
            >
              CANSADO DE OUVIR <span className="highlight-marker-solid">FRASES</span>
              <br className="hidden sm:block" /> COMO ESSAS?
            </h2>
            <p className="mt-3 md:mt-4 text-sm sm:text-base md:text-lg text-gray-400 max-w-2xl mx-auto px-2">
              Se alguma delas já passou pela sua cabeça (ou pelo ouvido),
              a <span className="text-yellow-400 font-semibold">mentoria WING Academy</span> foi feita pra você.
            </p>
          </div>

          {/* Cards */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {painPoints.map((item, idx) => {
              const Icon = item.icon;
              return (
                <div
                  key={idx}
                  data-testid={`pain-point-card-${idx}`}
                  className="glass border border-yellow-500/10 rounded-2xl p-5 sm:p-6 md:p-7 hover:border-yellow-500/40 md:hover:-translate-y-1 transition-all duration-300 group"
                >
                  <div className="w-11 h-11 md:w-14 md:h-14 rounded-xl bg-black border border-yellow-500/30 flex items-center justify-center mb-4 md:mb-5 group-hover:bg-yellow-500/10 transition-colors">
                    <Icon className="w-5 h-5 md:w-7 md:h-7 text-yellow-400" />
                  </div>
                  <p className="text-white text-base sm:text-lg md:text-xl font-semibold italic leading-snug mb-3">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                  <p className="text-gray-500 text-xs sm:text-sm">{item.context}</p>
                </div>
              );
            })}
          </div>

          {/* Bottom callout */}
          <div className="mt-10 md:mt-14 text-center">
            <div className="inline-flex items-center gap-3 bg-green-500/10 border border-green-500/30 px-5 py-3 rounded-full">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
              <span className="text-green-400 font-semibold text-sm md:text-base">
                Vamos resolver isso de forma prática e profissional.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
